import { unparse } from 'papaparse';
import { showErrorMessage } from './notifications';

export function downloadFile({
  contentType,
  data,
  filename,
}: {
  contentType: string;
  data: BlobPart;
  filename: string;
}) {
  const blob = new Blob([data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function downloadCSV({
  data,
  filename,
  errorLabel,
}: {
  data: Record<string, unknown>[];
  filename: string;
  errorLabel: string;
}) {
  try {
    const csvContent = unparse(data);
    downloadFile({
      contentType: 'text/csv;charset=utf-8;',
      data: csvContent,
      filename,
    });
  } catch {
    showErrorMessage({ message: `Failed to export ${errorLabel} CSV` });
  }
}
